<template>
<div>
    <b-container v-show="!showDetail">
        <b-row v-for="(item,$index) in newsList" :key="$index" class="tz-news" @click="showDetial(item)">
            <b-col sm="1">
                <div class="tz-news-date">
                    <div> {{new Date(item.createTime).getMonth()+1}}月</div>
                    <div>  {{new Date(item.createTime).getUTCDate()}}日</div>
                </div>
            </b-col>
            <b-col v-if="!!item.img" sm="2">
               <b-img class="tz-news-img" fluid :src="item.img"/>
            </b-col>
            <b-col sm="">
                <div class="tz-new-summary">
                    <div class="tz-news-title">{{item.title}} </div>
                    <div>{{item.plainText}}</div>
                    <div class="tz-new-time">
                     {{new Date(item.createTime).Format('yyyy-MM-dd hh:mm:ss')}}
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
    <b-container v-show="showDetail" class="tz-news-content">
        <div class="tz-news-title">{{showItem.title}} </div>
         <div class="tz-new-time">
                     {{new Date(showItem.createTime).Format('yyyy-MM-dd hh:mm:ss')}}
         </div>
        <div>{{showItem.plainText}}</div>
        <div class="tz-news-info" v-html="showItem.content" />
    </b-container>
</div>
</template>
<script>
export default {
    data(){
        return {
            newsList:[],
            showDetail: false,
            showItem: {}
        }
    },
    props:{
        news:{
            type: Array
        }
    },
    created(){
        // this.news.sort((a,b)=> {
        //    return  b.createTime - a.createTime
        // })
        // this.newsList = this.news
    },
    mounted(){
        console.log(this.news)
        this.news.sort((a,b)=> {
           return  b.createTime - a.createTime
        })
        this.newsList = this.news
    },
    methods:{
        showDetial(item){
            console.log(item)
            this.showItem = item
            this.showDetail = true
        }
    },
    watch:{
        news:{
            handler(nv,ov){
               
                this.showDetail =false
                this.newsList = nv
            }
        }
    }
}
</script>
<style scoped>
.tz-news-img{
    width: 8.5rem;
    height: 5.9375rem;
}
.tz-news{
    padding: 1rem;
    background: white;
    color: #666666;
    border-top: 1px solid #e6e6e6;
}
.tz-news>div{
    display: flex;
    align-items: center;
}
.tz-news-title{
    display: inline-block;
    font-size: 150%;
    font-weight: bolder;
    width: 100%;
}
.tz-news-date{
    position: relative;
    display: block;
    left: 0;
    background: #399ae7;
    color: white;
    width: 3rem;
    height: 3rem;
    margin-top: -5rem;
    margin-left: -1rem;
    padding-top: 8px;
    line-height: 1;

}
.tz-news-date::after{
    position: absolute;
    content: "";
    background:white;
    /* width: 1rem;
    height: 0.5rem; */
    top:0;
    right: -10px;
    width: 0;
    height: 0;
    border-top: 5px solid #399ae7;
    border-right: 10px solid transparent; 
}
.tz-new-summary{
    text-align: left;
    width: 100%;
    color: black;
}
.tz-new-time{
    position: relative;
    bottom: 0;
    width: 100%;
    text-align: right;
    color: #807b75;
}
.tz-news-content{
    background: white;
}
.tz-close{
    color: wheat;
    position: absolute;
    right: 19rem;
    top: 5rem;
    width: 1rem;
    height: 1rem;
}
.tz-news-info{
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/competition/news.vue